import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { fireVisitBeacon } from '@dogdisk/shared'
import { TitleManager } from './title-manager'

/** pathless 根布局:挂 TitleManager,渲染子路由。不改变任何页面渲染。 */
export function RootLayout() {
  // 访问信标:每浏览器每天最多发一次 POST /gapi/public/visit(cookie 自闸,fire-and-forget)。
  useEffect(() => {
    fireVisitBeacon()
  }, [])

  return (
    <>
      <TitleManager />
      <Outlet />
    </>
  )
}
